import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { CrudFilters, CrudSort, MetaQuery } from '@refinedev/core';
import { axiosInstance } from './axios';

class DeliveryChallanLotAPIClient extends CrudApiClient {
  itemFormat?: string;

  constructor(itemFormat?: string) {
    super(GATEWAY_API_URL + '/deliverychallan/:deliveryChallanId/lot');
    this.itemFormat = itemFormat;
  }

  resolveParameterizedUrlVariables(meta: MetaQuery | undefined) {
    let url = this.baseURL?.replace(':deliveryChallanId', meta?.deliveryChallanId);
    if (this.itemFormat && this.itemFormat === 'wondersoft') {
      url += '/' + meta?.lotId + '/wondersoft';
    }
    return url;
  }

  transformNode = (node: any) => {
    if (this.itemFormat && this.itemFormat == 'wondersoft') node.BatchDescription = '';
    return node;
  };

  async scan(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      let url = this.resolveParameterizedUrlVariables(meta);
      url += '/' + meta?.lotId + '/scan';
      const response = await axiosInstance.post(`${url}`, payload);
      return this.transformNode(response.data?.data);
    } catch (error) {
      throw error;
    }
  }

  async close(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      let url = this.resolveParameterizedUrlVariables(meta);
      url += '/' + meta?.lotId + '/close';
      const response = await axiosInstance.put(`${url}`, payload);
      return this.transformNode(response.data?.data);
    } catch (error) {
      throw error;
    }
  }
}

export default DeliveryChallanLotAPIClient;
